import { render, staticRenderFns } from "./DeashboardAdmin.vue?vue&type=template&id=f45de7e2&"
import script from "./DeashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./DeashboardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports